import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import { Switch, Route } from 'react-router-dom'
import Home from './Home'
import About from './About'
import Contact from './Contact'
import Partner from './Partner'
import signup from './signup'
import ThankYou from './ThankYou'

class Main extends Component {
  render() {
    return (
      <main>
        <Switch>
          <Route exact path='/' component={Home}/>
          <Route path='/about' component={About}/>
          <Route path='/contact' component={Contact}/>
          <Route path='/partner' component={Partner}/>
          <Route path='/signup' component={signup}/>
          <Route path='/thankyou' component={ThankYou}/>
        </Switch>
      </main>
    );
  }
}

export default Main;



// WEBPACK FOOTER //
// ./src/Main.js